import React from 'react';
import _ from 'lodash';
import {
  IconBadgeStatus,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

import useIntl from '../../../hooks/useIntl';
import componentMessages from '../messages';
import appMessages from '../../../containers/App/messages';

import DateTimeDisplay from '../DateTimeDisplay';
import ApplicationReceived from '../ApplicationReceived';
import ApplicationStatus from '../ApplicationStatus';

const messages = {
  ...appMessages,
  ...componentMessages,
};

export default function TrackedItem({
  item,
  status,
  data,
  applicationReceivedEditAllowed,
  applicationStatusChangeHandler,
  applicationStatuses,
  handleStatusChange,
  application,
  waitlistModalProps,
  applicationStatusUpdateAllowed,
  leaseExecuted,
  leaseSentToPortal,
  isResident,
  headOfHouseholdId,
  affordableWaitlistRecord,
  applicationStatusId,
  floorPlans,
  localWaitlistInfo,
  waitlistActions,
  organizationId,
  propertyId,
  refreshApplication,
}) {
  const intl = useIntl();
  return (
    <Stack
      direction={'column'}
      alignItems={'center'}
      sx={{
        flex: 1,
        gap: 1,
      }}
    >
      <Typography variant="titleMedium" color="text.primary">
        {intl.formatMessage(messages[_.camelCase(item)])}
      </Typography>

      <IconBadgeStatus variant={status} />

      {!['Application', 'Application Status'].includes(item) && (
        <>
          <Stack direction="row" gap={1}>
            <DateTimeDisplay data={data} />
          </Stack>
        </>
      )}

      {item === 'Application' && (
        <ApplicationReceived
          editMode={data?.editMode}
          setEditMode={data?.setEditMode}
          date={data?.date ?? null}
          time={data?.dateTime ?? null}
          dateTime={data?.dateTime ?? null}
          setDate={data?.setDate}
          setTime={data?.setTime}
          handleSave={data?.handleSave}
          loading={data?.loading}
          item={item}
          data={data}
          applicationReceivedEditAllowed={applicationReceivedEditAllowed}
        />
      )}

      {item === 'Application Status' && (
        <ApplicationStatus
          applicationStatusChangeHandler={applicationStatusChangeHandler}
          applicationStatuses={applicationStatuses}
          handleStatusChange={handleStatusChange}
          application={application}
          waitlistModalProps={waitlistModalProps}
          applicationStatusUpdateAllowed={applicationStatusUpdateAllowed}
          leaseExecuted={leaseExecuted}
          leaseSentToPortal={leaseSentToPortal}
          isResident={isResident}
          headOfHouseholdId={headOfHouseholdId}
          affordableWaitlistRecord={affordableWaitlistRecord}
          applicationStatusId={applicationStatusId}
          floorPlans={floorPlans}
          localWaitlistInfo={localWaitlistInfo}
          waitlistActions={waitlistActions}
          organizationId={organizationId}
          propertyId={propertyId}
          refreshApplication={refreshApplication}
        />
      )}
    </Stack>
  );
}
